import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import styles from '../SupplierProfiles.module.scss';
import { useTranslation } from 'react-i18next';

type SupplierTableProps = React.PropsWithChildren;

export const SuppliersTable: React.FC<SupplierTableProps> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <TableContainer
      component={Paper}
      className={styles.table_container}
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        maxHeight: 'calc(100vh - 179px)',
        overflow: 'auto',
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{t('labels.name')}</TableCell>
            <TableCell>{t('labels.email')}</TableCell>
            <TableCell>{t('labels.phone')}</TableCell>
            <TableCell>{t('labels.address')}</TableCell>
            <TableCell align='right' />
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};
